/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-12 18:13:57
 * @LastEditors: changfeng
 * @LastEditTime: 2024-04-14 13:31:50
 */
import { AnyAction } from "redux";
import { ADState } from "@/redux/interface";
import produce from "immer";
import * as types from "@/redux/mutation-types";

const adgroup = {
	copyCount: 1,
	targetAccount: {},
	copyDay: 0,
	isEveryDayCopy: false,
	everyDayCopyCount: 0,
	sourceIsSmartCreative: false,
	sourceCampaignInfo: {
		campaignName: ""
	},
	campaignNameList: [],
	adgroupNameList: [],
	campaignFormInfo: {},

	/** 存Smart的表单信息 */
	SmartADText: [],

	/** 存素材信息 */
	materialList: [],
	/** 存Smart素材信息 */
	smartMaterialList: [],
	smartAdAttribute: {},
	curOperationMaterial: {},
	identity: {},
	sourceAdgroupInfo: {},
	currentAdgroupInfo: {}
};

// auth reducer
const COPYADGROUP = (state = adgroup, action: AnyAction) =>
	produce(state, draftState => {
		switch (action.type) {
			case "SET_COPY_ADGROUP_COPY_COUNT":
				draftState.copyCount = action.count;
				break;
			case "SET_COPY_ADGROUP_TARGET_ADVERTISER":
				draftState.targetAccount = action.adAccount;
			case "SET_COPY_ADGROUP_IS_EVERYDAY_COPY":
				draftState.isEveryDayCopy = action.isEveryDay;
				break;
			case "SET_COPY_ADGROUP_COPY_DAYS":
				draftState.copyDays = action.days;
				break;
			case "SET_COPY_ADGROUP_EVERY_DAY_COPY_COUNT":
				draftState.everyDayCopyCount = action.count;
				break;
			case "SET_COPY_ADGROUP_SOURCECAMPAIGN_IS_SMARTCREATIVE":
				draftState.sourceIsSmartCreative = action.creativeType;
				break;
			// case "SET_COPY_ADGROUP_SOURCECAMPAIGN_ADGROUP_INFO":
			// 	draftState.sourceCampaignAdgroupInfo = action.adgroup;
			// 	break;
			case "SET_COPY_ADGROUP_SOURCECAMPAIGN_CAMPAIGN_INFO":
				draftState.sourceCampaignInfo = action.campaign;
				break;
			case "SET_COPY_ADGROUP_CAMPAIG_NNAME_LIST":
				draftState.campaignNameList = action.campaignNameList;
				break;
			case "SET_COPY_ADGROUP_ADGROUP_NAME_LIST":
				draftState.adgroupNameList = action.adgroupNameList;
				break;
			case "SET_COPY_ADGROUP_CAMPAIGN_FORM_INFO":
				draftState.campaignFormInfo = action.campaign;
				break;
			case "SET_COPY_ADGROUP_COPY_MATERIAL_LIST":
				draftState.materialList = [...action.ad];
				break;
			case "SET_COPY_ADGROUP_COPY_SMART_MATERIAL_LIST":
				draftState.smartMaterialList = action.smartAd;
				break;
			case "SET_COPY_ADGROUP_SMART_AD_TEXT":
				draftState.SmartADText = action.smartAdText;
				break;
			case "SET_COPY_ADGROUP_SMART_AD_ATTRIBUTE":
				draftState.smartAdAttribute = action.smartAdAttribute;
				break;
			case "SET_COPY_ADGROUP_CURRENT_OPERATION_MATERIAL":
				draftState.curOperationMaterial = action.material;
				break;
			case "SET_SOURCE_ADGROUP_INFO":
				draftState.sourceAdgroupInfo = action.sourceadgroup;
				break;
			case "SET_CURRENT_ADGROUP_INFO":
				draftState.currentAdgroupInfo = action.currentadgroup;
				break;
			case "SET_COPY_ADGROUP_IDENTITY":
				draftState.identity = action.identity;
				break;
			default:
				return draftState;
		}
	});

export default COPYADGROUP;
